import classNames from 'classnames';
import { ReactComponent as Twitter } from 'assets/icons/twitter.svg';
import { ReactComponent as Dribbble } from 'assets/icons/dribbble.svg';
import { ReactComponent as Github } from 'assets/icons/github.svg';
import { ReactComponent as Error } from 'assets/icons/error.svg';
import { ReactComponent as Menu } from 'assets/icons/menu.svg';
import { ReactComponent as ArrowRight } from 'assets/icons/arrow-right.svg';
import { ReactComponent as ChevronRight } from 'assets/icons/chevron-right.svg';
import { ReactComponent as Close } from 'assets/icons/close.svg';
import { ReactComponent as Send } from 'assets/icons/send.svg';
import { ReactComponent as Play } from 'assets/icons/play.svg';
import { ReactComponent as Pause } from 'assets/icons/pause.svg';
import { ReactComponent as Figma } from 'assets/icons/figma.svg';
import { ReactComponent as Gmail } from 'assets/icons/gmail.svg';
import { ReactComponent as facebook } from 'assets/icons/facebook.svg';
import { ReactComponent as instgram } from 'assets/icons/instgram.svg';
import { ReactComponent as whatsapp } from 'assets/icons/whatsapp.svg';
import { ReactComponent as Linkedin } from 'assets/icons/linkedin.svg';
import { ReactComponent as behance } from 'assets/icons/behance.svg';
import { ReactComponent as Check } from 'assets/icons/check.svg'; // Import the check icon
import './index.css';

export const icons = {
  twitter: Twitter,
  dribbble: Dribbble,
  github: Github,
  error: Error,
  menu: Menu,
  arrowRight: ArrowRight,
  chevronRight: ChevronRight,
  close: Close,
  send: Send,
  play: Play,
  pause: Pause,
  figma: Figma,
  gmail: Gmail,
  linkedin: Linkedin,
  facebook: facebook,
  instagram: instgram,
  whatsapp: whatsapp,
  behance: behance,
  check: Check, // Add the check icon
};

const Icon = ({ icon, style, className, ...rest }) => {
  const IconComponent = icons[icon];

  // If the icon is not found, render a fallback (e.g., an empty span)
  if (!IconComponent) {
    console.warn(`Icon "${icon}" not found.`);
    return <span className={classNames('icon', className)} {...rest} />;
  }

  return (
    <IconComponent aria-hidden className={classNames('icon', className)} {...rest} />
  );
};

export default Icon;